import { useMemo } from 'react';

import { useConnections } from 'wagmi';
// TODO - de-dup
export function useMetaMask() {
    const connections = useConnections();
    const metamaskConnections = useMemo(() => {
        return connections?.find((connection) => connection.connector.id === 'metaMask');
    }, [connections]);
    return {
        isMetaMaskConnected: !!metamaskConnections,
        account: metamaskConnections?.accounts?.[0],
    };
}
